import React from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import type { CommandPalette } from '@atlassian/jira-forge-ui/src/ui/components/command-palette/index.tsx';

import {
	COMMAND_PALETTE_MODULE,
	CONTEXT_TOKEN_TYPE_JIRA,
} from '@atlassian/jira-forge-ui-constants/src/constants.tsx';
import type { LazyComponentProps } from '../../types.tsx';
import { LazyCommandPaletteRenderer } from '../../common/ui/extension/command-palette/index.tsx';

type Props = Omit<
	LazyComponentProps<typeof CommandPalette>,
	'entryPoint' | 'extensionData' | 'module'
>;

const extensionData = {
	type: COMMAND_PALETTE_MODULE,
};

const extraProps = {
	module: COMMAND_PALETTE_MODULE,
	type: COMMAND_PALETTE_MODULE,
	extensionData,
	contextToken: CONTEXT_TOKEN_TYPE_JIRA,
};

export const AsyncCommandPalette = (props: Props): React.JSX.Element => {
	return (
		<Placeholder name="command-palette-extension">
			<LazyCommandPaletteRenderer {...props} {...extraProps} />
		</Placeholder>
	);
};
